import React from 'react';
import './Player.css'
import {Col, Button} from 'react-bootstrap';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
const Player = (props) => {
    const handleAddPlayer = props.handleAddPlayer;
    return (
        <Col xs={4}>
            <div className="player">
                <img src={props.player.img} alt={props.player.name} className="player_image" />
                <h2 className="player_name">{props.player.name}</h2>
                <h2 className="player_information">Salary: ${props.player.salary}</h2>
                <h2 className="player_information">Age: {props.player.age}</h2>
                <h2 className="player_information">Type: {props.player.feature}</h2>
                <h2 className="player_information">Club: {props.player.address}</h2>
                <Button variant="primary" onClick={() => handleAddPlayer(props.player.salary)}>Add Player</Button>
                {/* <FontAwesomeIcon icon={"cart"} /> */}
            </div>
        </Col>
        
    );
};

export default Player;
